/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { ImageManagementListLiveImageResponse } from './ImageManagementListLiveImageResponse';

export type ImageManagementListLiveImageResponseApiRespoonse = {
    data?: ImageManagementListLiveImageResponse;
    status?: ImageManagementListLiveImageResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace ImageManagementListLiveImageResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

